"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconBase = void 0;

var _stylitas = require("@creditas/stylitas");

const iconBase = ({
  width = '48px',
  height = '48px'
}) => (0, _stylitas.css)`
  display: flex;
  align-items: center;
  width: ${width};
  height: ${height};
  box-sizing: border-box;
  & > svg {
    width: 100%;
    height: 100%;
  }
`;

exports.iconBase = iconBase;